var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCfMenuDosage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 14.0625,
    height: 21.875,
    viewBox: "0 0 14.0625 21.875",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.2883 5.97734C11.9756 5.89912 11.6902 5.73709 11.4628 5.50871C11.2354 5.28033 11.0746 4.99424 10.9977 4.68125C11.4005 4.66573 11.7817 4.49514 12.0617 4.20512C12.3416 3.9151 12.4987 3.5281 12.5 3.125V1.5625C12.5 1.1481 12.3354 0.750671 12.0424 0.457646C11.7493 0.16462 11.3519 0 10.9375 0H3.125C2.7106 0 2.31317 0.16462 2.02015 0.457646C1.72712 0.750671 1.5625 1.1481 1.5625 1.5625V3.125C1.56382 3.52823 1.72098 3.91534 2.00112 4.20538C2.28126 4.49542 2.66268 4.66593 3.06563 4.68125C2.98842 4.99422 2.8274 5.28025 2.59988 5.5086C2.37235 5.73695 2.08691 5.899 1.77422 5.97734C1.26726 6.10434 0.817293 6.39714 0.495827 6.8092C0.17436 7.22126 -0.000160352 7.72894 1.10554e-07 8.25156V19.5312C1.10554e-07 20.1529 0.24693 20.749 0.686469 21.1885C1.12601 21.6281 1.72215 21.875 2.34375 21.875H11.7188C12.3404 21.875 12.9365 21.6281 13.376 21.1885C13.8156 20.749 14.0625 20.1529 14.0625 19.5312V8.25156C14.0627 7.72894 13.8881 7.22126 13.5667 6.8092C13.2452 6.39714 12.7952 6.10434 12.2883 5.97734ZM3.125 1.5625H10.9375V3.125H3.125V1.5625ZM12.5 19.5312C12.5 19.7385 12.4177 19.9372 12.2712 20.0837C12.1247 20.2302 11.926 20.3125 11.7188 20.3125H2.34375C2.13655 20.3125 1.93784 20.2302 1.79132 20.0837C1.64481 19.9372 1.5625 19.7385 1.5625 19.5312V8.25156C1.56233 8.07727 1.62045 7.90792 1.72762 7.77046C1.83478 7.633 1.98483 7.53532 2.15391 7.49297C2.80504 7.33119 3.39234 6.97701 3.83925 6.47659C4.28616 5.97616 4.57195 5.35271 4.65937 4.6875H9.40312C9.49055 5.35271 9.77634 5.97616 10.2232 6.47659C10.6702 6.97701 11.2575 7.33119 11.9086 7.49297C12.0777 7.53532 12.2277 7.633 12.3349 7.77046C12.442 7.90792 12.5002 8.07727 12.5 8.25156V19.5312Z",
    fill: "url(#paint0_linear_0_9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.375 12.5H7.8125V10.9375C7.8125 10.7303 7.73019 10.5316 7.58368 10.3851C7.43716 10.2386 7.23845 10.1562 7.03125 10.1562C6.82405 10.1562 6.62534 10.2386 6.47882 10.3851C6.33231 10.5316 6.25 10.7303 6.25 10.9375V12.5H4.6875C4.4803 12.5 4.28159 12.5823 4.13507 12.7288C3.98856 12.8753 3.90625 13.074 3.90625 13.2812C3.90625 13.4885 3.98856 13.6872 4.13507 13.8337C4.28159 13.9802 4.4803 14.0625 4.6875 14.0625H6.25V15.625C6.25 15.8322 6.33231 16.0309 6.47882 16.1774C6.62534 16.3239 6.82405 16.4062 7.03125 16.4062C7.23845 16.4062 7.43716 16.3239 7.58368 16.1774C7.73019 16.0309 7.8125 15.8322 7.8125 15.625V14.0625H9.375C9.5822 14.0625 9.78091 13.9802 9.92743 13.8337C10.0739 13.6872 10.1562 13.4885 10.1562 13.2812C10.1562 13.074 10.0739 12.8753 9.92743 12.7288C9.78091 12.5823 9.5822 12.5 9.375 12.5Z",
    fill: "url(#paint1_linear_0_9)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_9",
    x1: 0,
    y1: 10.9375,
    x2: 14.0625,
    y2: 10.9375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#269C6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ABA47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_9",
    x1: 3.90625,
    y1: 13.2812,
    x2: 10.1562,
    y2: 13.2812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#269C6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ABA47"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCfMenuDosage);
export default __webpack_public_path__ + "static/media/cf-menu-dosage.3cf4f7c25a2a328876345bcf09213199.svg";
export { ForwardRef as ReactComponent };